import { render, staticRenderFns } from "./TranUserPackageList.vue?vue&type=template&id=19cc27bb&scoped=true"
import script from "./TranUserPackageList.vue?vue&type=script&lang=js"
export * from "./TranUserPackageList.vue?vue&type=script&lang=js"
import style0 from "./TranUserPackageList.vue?vue&type=style&index=0&id=19cc27bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cc27bb",
  null
  
)

export default component.exports